var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 622,
    viewBox: "0 0 622 622",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 311,
    r: 311,
    fill: "#FFA824"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.66 407H199C173.539 407 149.121 396.886 131.118 378.882C113.114 360.879 103 336.461 103 311C103 285.539 113.114 261.121 131.118 243.118C149.121 225.114 173.539 215 199 215H254.41",
    stroke: "white",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.59 215H423C448.461 215 472.879 225.114 490.882 243.118C508.886 261.121 519 285.539 519 311C519 336.461 508.886 360.879 490.882 378.882C472.879 396.886 448.461 407 423 407H366.34",
    stroke: "white",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.07 311H399.93",
    stroke: "white",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3f848ccc8e54fbbcb01ede13c6aa5e89.svg";
export { ForwardRef as ReactComponent };